<template>
  <div class="policy-section mb-4" :class="{ 'highlight-section': highlight }">
    <div class="section-header d-flex align-items-center mb-3">
      <div
        class="icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle"
        :class="
          highlight ? 'bg-danger bg-opacity-10' : 'bg-success bg-opacity-10'
        "
      >
        <i
          :class="[icon, highlight ? 'text-danger' : 'text-success']"
          style="font-size: 14px"
        ></i>
      </div>
      <h5
        class="fw-bold mb-0 text-dark section-title"
        style="font-weight: 700 !important"
      >
        {{ title }}
      </h5>
    </div>
    <div class="section-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PolicySection",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "fas fa-circle",
    },
    highlight: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.policy-section {
  padding: 24px 28px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  border-radius: 16px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 168, 28, 0.06);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.policy-section::before {
  content: "";
  position: absolute;
  top: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #00a81c 0%, #00d426 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

[dir="rtl"] .policy-section::before {
  right: 0;
  left: auto;
  border-radius: 0 16px 16px 0;
}

[dir="ltr"] .policy-section::before {
  left: 0;
  right: auto;
  border-radius: 16px 0 0 16px;
}

.policy-section:hover {
  box-shadow: 0 8px 24px rgba(0, 168, 28, 0.12);
  transform: translateY(-2px);
}

.policy-section:hover::before {
  opacity: 1;
}

.highlight-section {
  background: linear-gradient(135deg, #fff5f5 0%, #fff0f0 100%);
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.08);
}

.highlight-section::before {
  background: linear-gradient(180deg, #dc3545 0%, #ff6b7a 100%);
}

.highlight-section:hover {
  box-shadow: 0 8px 24px rgba(220, 53, 69, 0.15);
}

.icon-wrapper {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 168, 28, 0.15);
  transition: all 0.3s ease;
  margin-inline-end: 14px;
}

.policy-section:hover .icon-wrapper {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 168, 28, 0.2);
}

.highlight-section .icon-wrapper {
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.15);
}

.highlight-section:hover .icon-wrapper {
  box-shadow: 0 6px 16px rgba(220, 53, 69, 0.2);
}

.section-title {
  border: none !important;
  border-bottom: none !important;
  margin: 0 !important;
  font-size: 18px;
  color: #1a1a2e;
  letter-spacing: -0.3px;
  background: none;
  outline: none;
}

.section-content {
  padding-top: 12px;
  padding-inline-start: 58px;
}

.section-content p {
  margin-bottom: 14px;
  color: #4a4a5a;
  line-height: 1.75;
}

.section-content ul {
  margin-bottom: 0;
  padding-inline-start: 24px;
}

.section-content ul li {
  position: relative;
  padding: 6px 8px;
  margin-bottom: 6px;
  color: #4a4a5a;
  line-height: 1.7;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.section-content ul li:hover {
  background-color: rgba(0, 168, 28, 0.04);
}

.highlight-section .section-content ul li:hover {
  background-color: rgba(220, 53, 69, 0.04);
}

.section-content ul li::marker {
  color: #00a81c;
}

.highlight-section .section-content ul li::marker {
  color: #dc3545;
}

@media (max-width: 767.98px) {
  .policy-section {
    padding: 18px 20px;
    border-radius: 12px;
  }

  .section-header {
    flex-wrap: nowrap;
  }

  .section-title {
    font-size: 16px !important;
  }

  .icon-wrapper {
    width: 38px;
    height: 38px;
  }

  .section-content {
    padding-inline-start: 0;
  }
}
</style>
